import { Optician, Error, Welcome, Patient } from './screens';
import { EndOfTest } from './screens/patient';
import { AppointmentProvider, useAppointment } from './context/appointmentContext';
import { TestProvider } from './context/testContext';
import { VideoProvider } from './context/videoContext';
import { CalibrationProvider } from './context/calibrationContext';
import { MessageProvider } from './context/messageContext';
import { OpenCvProvider } from 'opencv-react';
import { GlobalStyle } from './2022-component-library';
import { getCustomTheme } from './helpers/getCustomTheme';
import {
  ResponsiveOpticianContainer,
  ResponsivePatientContainer,
  ResponsiveWelcome,
  ResponsiveError,
  ResponsiveLoadingPage,
} from './screens/responsive-views';
import { Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { NavigationProvider } from './context/navigationContext';
import { SessionStateProvider } from './context/sessionStateContext';
import { SessionUIProvider } from './ui/Dialog';

const AuthenticatedApp = () => {
  const [themeLoaded, setThemeLoaded] = useState(false);
  const desktopView = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)').matches;

  useEffect(() => {
    const delay = setTimeout(() => getCustomTheme().then(() => setThemeLoaded(true)), 1000);
    return () => clearTimeout(delay);
  }, []);

  return !themeLoaded ? (
    <ResponsiveLoadingPage />
  ) : (
    <AppointmentProvider>
      <MessageProvider>
        <SessionStateProvider>
        <SessionUIProvider>
        <CalibrationProvider>
          <TestProvider>
            <OpenCvProvider>
              <VideoProvider>
                <NavigationProvider>
                  <RoleRoutes desktopView={desktopView} />
                </NavigationProvider>
              </VideoProvider>
            </OpenCvProvider>
          </TestProvider>
        </CalibrationProvider>
        </SessionUIProvider>
        </SessionStateProvider>
      </MessageProvider>
    </AppointmentProvider>
  );
};

// Patients on non-desktop devices get the responsive views. The role comes from
// api/users/current (see AppointmentProvider), since the new dashboard and the ticket
// login never write localStorage.loggedUser.
const RoleRoutes = ({ desktopView }) => {
  const { userRole, userResolved } = useAppointment();
  if (desktopView) return <DesktopRoutes />;
  if (!userRole && !userResolved) return <ResponsiveLoadingPage />;
  return userRole === 'patient' ? <ResponsiveRoutes /> : <DesktopRoutes />;
};

const ResponsiveRoutes = () => {
  return (
    <>
      <GlobalStyle />
      <Routes>
        <Route path='*' element={<ResponsiveWelcome />} />
        <Route path={`${process.env.PUBLIC_URL}/welcome`} element={<ResponsiveWelcome />} />
        <Route path={`${process.env.PUBLIC_URL}/:roomName`} element={<ResponsiveWelcome />} />
        <Route path={`${process.env.PUBLIC_URL}/clinician`} element={<ResponsiveOpticianContainer />} />
        <Route path={`${process.env.PUBLIC_URL}/patient`} element={<ResponsivePatientContainer />} />
        <Route path={`${process.env.PUBLIC_URL}/error`} element={<ResponsiveError />} />
      </Routes>
    </>
  );
};

const DesktopRoutes = () => {
  return (
    <Routes>
      <Route path='*' element={<Welcome />} />
      <Route path={`${process.env.PUBLIC_URL}/welcome`} element={<Welcome />} />
      <Route path={`${process.env.PUBLIC_URL}/:roomName`} element={<Welcome />} />
      <Route path={`${process.env.PUBLIC_URL}/clinician`} element={<Optician />} />
      <Route path={`${process.env.PUBLIC_URL}/patient`} element={<Patient />} />
      <Route path={`${process.env.PUBLIC_URL}/end-of-test`} element={<EndOfTest />} />
      <Route path={`${process.env.PUBLIC_URL}/error`} element={<Error />} />
    </Routes>
  );
};

export default AuthenticatedApp;
